
let linkActiveClass = 'uk-active';


export default {
    'requiresGuestRedirect' : '/',
    'requiresUserRedirect' : '/user/login',
    'linkActiveClass': linkActiveClass
}
